import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifymodal',
  templateUrl: './notifymodal.component.html',
  styleUrls: ['./notifymodal.component.css']
})
export class NotifymodalComponent implements OnInit {

text:string;
subject:string;
isSuccess:boolean;

  constructor(
    private dialogRef: MatDialogRef<NotifymodalComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.isSuccess = this.data.isSuccess;
    this.text = this.data.text;
    this.subject = this.data.subject;
   }

  ngOnInit(): void {
    if(this.subject == "Login Guard" || this.subject == "First Login"){
      this.dialogRef.disableClose = true;
    }
  }

  exit(){
    if(this.subject == "Login Guard"){
      this.router.navigate(['']);
    }else if(this.subject == "First Login"){
      this.router.navigate(['dashboard/sifreDegistir']);
    }

    this.dialogRef.close();
  }

}
